// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4989":"18a0350cf6627c869f6f","9249":"88ac414526cd5a5a6dde"}[chunkId] + ".chunk.js";
};